import { AxiosError } from 'axios';
import { QueryConfig, useQuery } from 'react-query';
import { __DEV__ } from '~src/config';
import {
  loadFilesActionLog,
  LoadFilesActionLogParams,
} from '~src/services/api/actionLogs';
import { DbFileActionLog } from '~src/types/db';
import { useProjectId } from '../useProjectId';

type UseFilesActionLogProps = Omit<LoadFilesActionLogParams, 'projectId'>;

interface ReturnType {
  logs: DbFileActionLog[];
  totalCount: number;
}

export const useFilesActionLog = (
  { skip, take, before, after, response_type }: UseFilesActionLogProps = {},
  queryConfig: QueryConfig<ReturnType, AxiosError> & {
    enabled?: boolean;
  }
) => {
  const projectId = useProjectId();

  const { enabled, ...options } = queryConfig;

  // if enabled = undefined then enabled = true
  const enabledOverwrite = enabled || enabled === undefined;

  const filesActionLogQuery = useQuery<ReturnType, AxiosError>(
    [
      'filesActionLog',
      {
        projectId: Number(projectId),
        skip,
        take,
        before,
        after,
        response_type,
      },
    ],
    loadFilesActionLog,
    {
      // refetch every 5 min
      refetchInterval: 5 * 60 * 1000,
      enabled: enabledOverwrite && projectId,
      refetchOnWindowFocus: !__DEV__,
      ...options,
    }
  );

  return filesActionLogQuery;
};
